import React, { useContext } from 'react';
import { style } from 'typestyle';
import { useCompanies } from './hooks/companies.hook';
import CompanyOverviewGroup from './groups/company-overview-group.component';
import { IsMobileContext } from '../../core/context/is-mobile';
import CommonStyles from '../../core/common.styles';
import Column from '../../core/components/column/column.component';
import { CrossAxisAlignment } from '../../core/components/flex/flex.component';

const CompanyOverview = (): React.JSX.Element => {
  const companiesState = useCompanies();
  const isMobile = useContext(IsMobileContext);
  const { companies } = companiesState;

  return (
    <div className={style(CommonStyles.pageMargin)}>
      <Column className={style(CommonStyles.bodyMargin(isMobile))} crossAxisAlignment={CrossAxisAlignment.Stretch}>
        <CompanyOverviewGroup allCompanies={companies} />
      </Column>
    </div>
  );
};

export default CompanyOverview;
